import InvoicingBase from "./InvoicingBase";
import Confirm from "./Confirm";
import DebtSettings from "./DebtSettings";

const mapping = {
  INVOICING_BASE: InvoicingBase,
  DEBT_SETTINGS: DebtSettings,
  CONFIRM: Confirm,
};

export default mapping;
